import { GridColDef } from '@mui/x-data-grid-pro';
import { useIntl } from 'react-intl';

export const useAccuracyMatrix = () => {
  const intl = useIntl();

  const useFetchDataGridData = () => {
    return [];
  };

  const confusionMatrixColumns: GridColDef[] = [
    {
      field: '',
      headerName: '',
      flex: 1,
      type: 'string',
      minWidth: 306,
      filterable: false,
      sortable: false,
      renderCell: () => {
        return <b>Model</b>;
      },
    },
    {
      field: 'truePositives',
      headerName: intl.formatMessage({ id: 'dataReliability.columnTruePositive' }),
      flex: 1,
    },
    {
      field: 'falsePositives',
      headerName: intl.formatMessage({ id: 'dataReliability.columnFalsePositive' }),
      flex: 1,
    },
    {
      field: 'falseNegatives',
      headerName: intl.formatMessage({ id: 'dataReliability.columnFalseNegative' }),
      flex: 1,
    },
  ];
  return {
    useFetchDataGridData,
    confusionMatrixColumns,
  };
};
